var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 361,
    viewBox: "0 0 256 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.555 70.766L232.314 331.126L127.844 360.088L23.6619 331.166L0.444946 70.766H255.555Z",
    fill: "#E44D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 337.95L212.417 314.547L232.277 92.057H128V337.95Z",
    fill: "#F16529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.82 155.932H128V123.995H47.917L48.681 132.563L56.531 220.573H128V188.636H85.739L82.82 155.932V155.932ZM90.018 236.542H57.958L62.432 286.688L127.853 304.848L128 304.808V271.58L127.86 271.617L92.292 262.013L90.018 236.542Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1801 0H40.4101V16.035H55.2571V0H71.4881V48.558H55.2581V32.298H40.4111V48.558H24.1811V0H24.1801ZM92.8301 16.103H78.5441V0H123.358V16.103H109.063V48.558H92.8331V16.103H92.8321H92.8301ZM130.47 0H147.393L157.803 17.062L168.203 0H185.133V48.558H168.969V24.49L157.803 41.755H157.523L146.35 24.49V48.558H130.47V0ZM193.21 0H209.445V32.508H232.269V48.558H193.209V0H193.21Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.89 220.573H167.217L163.509 261.993L127.889 271.607V304.833L193.362 286.688L193.842 281.292L201.348 197.212L202.127 188.636H127.89V220.573ZM127.89 155.854V155.932H205.033L205.673 148.754L207.129 132.563L207.892 123.995H127.89V155.855V155.854Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.754a28a2f7ca7d93e6d219923d30bb55.svg";
export { ForwardRef as ReactComponent };